import { render, staticRenderFns } from "./add_config.vue?vue&type=template&id=3968ea7e&"
import script from "./add_config.vue?vue&type=script&lang=js&"
export * from "./add_config.vue?vue&type=script&lang=js&"
import style0 from "./add_config.vue?vue&type=style&index=0&id=3968ea7e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports